module.exports = __webpack_public_path__ + "media/images/icons/coffee-0aaa87d77e18c6d1f76b8cfea37c74af.svg";